import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, NgModule } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Actions, NgxsModule, ofActionErrored, select } from '@ngxs/store';
import { AnimateModule, BasicPage, HeaderComponent, WwwRouteSlug } from '@pro-connect/shared';
import { ToastrService } from 'ngx-toastr';
import { ProEduTraTicComponent } from '../../../pro-education/pages/pro-education-training/components/pro-edu-tra-tic/pro-edu-tra-tic.component';
import { ProEduTraTopComponent } from '../../../pro-education/pages/pro-education-training/components/pro-edu-tra-top/pro-edu-tra-top.component';
import { ProExpConRedTxtComponent } from './components/pro-exp-con-red-txt/pro-exp-con-red-txt.component';
import { ProExpExpertsSliderComponent } from './components/pro-exp-experts-slider/pro-exp-experts-slider.component';
import { ProExperienceEventState, ProExperienceEventStateGetEventDetails } from './pro-experience-event.state';

@NgModule({
  imports: [NgxsModule.forFeature([ProExperienceEventState])],
})
class ProExperienceEventStateLazyModule {}

@Component({
  templateUrl: './pro-experience-event.component.html',
  styleUrls: ['./pro-experience-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    AnimateModule,
    ProExperienceEventStateLazyModule,
    HeaderComponent,
    ProEduTraTopComponent,
    ProEduTraTicComponent,
    ProExpConRedTxtComponent,
    ProExpExpertsSliderComponent,
  ],
})
export class ProExperienceEventComponent extends BasicPage {
  public override readonly loading = select(ProExperienceEventState.loading);
  public readonly eventDetails = select(ProExperienceEventState.event);
  // public readonly eventDetails = select(ProExperienceEventState.marke);
  public readonly WwwRouteSlug = WwwRouteSlug;
  public slug = '';
  private _activatedRoute = inject(ActivatedRoute);

  constructor(
    private readonly _actions$: Actions,
    private readonly _toastrService: ToastrService,
  ) {
    super();
    this.slug = this._activatedRoute.snapshot.params['slug'];
    this._store.dispatch([new ProExperienceEventStateGetEventDetails({ slug: this.slug })]);
    this._setActionsSubscriptions();
  }

  private _setActionsSubscriptions(): void {
    this._actions$
      .pipe(takeUntilDestroyed(this._destroyRef), ofActionErrored(ProExperienceEventStateGetEventDetails))
      .subscribe(() => {
        this._toastrService.warning('Wydarzenie nie istnieje', 'Błąd');
      });
  }
}
